module.exports = __webpack_public_path__ + "img/bg-proyectos-7.d69e9415.png";